import { render, staticRenderFns } from "./TeachCourse.vue?vue&type=template&id=4aa112ea&scoped=true"
import script from "./TeachCourse.vue?vue&type=script&lang=ts"
export * from "./TeachCourse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa112ea",
  null
  
)

export default component.exports